import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
`;

export const Content = styled.div`
  width: 80%;
  margin-left: 6rem;
  padding-top: 6rem;
`;

export const NoContentMessage = styled.p`
  text-align: center;
  font-size: 3rem;
`;
